import React from "react";
import { func, string } from "prop-types";
import { useRouter } from "next/router";

import MoreInformation from "../shared/MoreInformation";
import TestDrivePointLogo from "./FilterResultItems/TestDrivePointLogo";
import Typography from "../shared/Typography";

import gtm from "@gtm/core";
import { testDriveType } from "@types";
import { TEST_DRIVE_TYPE_ID } from "@shared/constants";

import {
  testDriveClickedResultDessaiUpdateUrlEvent,
  testDriveClickedResultFnacUpdateUrlEvent,
  testDriveFree2MoveUpdateUrlEvent,
  testDriveMoreInfoEvent,
} from "@gtm/events/testdrive";

const TestDriveType = ({ testDriveType, setTypeFilter, affiliation }) => {
  const {
    additionalDescription,
    colorHexa,
    description,
    label,
  } = testDriveType;

  const router = useRouter();

  const gtmEvent = eventAction =>
    gtm.fire(
      testDriveMoreInfoEvent({
        action: eventAction,
        label,
      })
    );

  const changeTypeFilter = () => {
    setTypeFilter(testDriveType.id);

    switch (testDriveType.id) {
      case TEST_DRIVE_TYPE_ID.STORE:
        gtm.fire(
          testDriveClickedResultDessaiUpdateUrlEvent({
            pageTitle: router.asPath,
            affiliation,
          })
        );
        return;

      case TEST_DRIVE_TYPE_ID.FNAC_DARTY:
        gtm.fire(
          testDriveClickedResultFnacUpdateUrlEvent({
            pageTitle: router.asPath,
            affiliation,
          })
        );
        return;

      case TEST_DRIVE_TYPE_ID.F2M:
        gtm.fire(
          testDriveFree2MoveUpdateUrlEvent({
            pageTitle: router.asPath,
            affiliation,
          })
        );
        return;
    }
  };

  return (
    <div className="flex items-start gap-4 w-full">
      <div
        className="min-w-10 cursor-pointer"
        onClick={changeTypeFilter}
        style={{ color: `#${colorHexa}` }}
      >
        <TestDrivePointLogo testDriveType={testDriveType} />
      </div>
      <div className="flex flex-col gap-2">
        <h3
          className="flex items-center cursor-pointer text-lg uppercase font-semibold text-primaryDark"
          onClick={changeTypeFilter}
        >
          {label}
        </h3>
        <div>
          <Typography className="text-sm">{description}</Typography>
          <MoreInformation
            isHtmlStringContent
            gtmEvent={gtmEvent}
            label={label}
            expansionMode="above"
          >
            {additionalDescription}
          </MoreInformation>
        </div>
      </div>
    </div>
  );
};

TestDriveType.propTypes = {
  testDriveType: testDriveType.isRequired,
  setTypeFilter: func,
  affiliation: string,
};

export default TestDriveType;
